<div class="internal-logo-parent">
  <div class="internal-logos">
    <img [ngClass]="(brand === 'Audi Now' || brand === 'AU') ? 'internal-logo-img-au' : 'internal-logo-img-vw'" [src]="internalImage" />
    <img *ngIf="secondaryInternalImage" class="internal-logo-second-img" [src]="secondaryInternalImage" alt="Secondary Logo" /> 
  </div>
</div>

<div class="flex-parent" [ngClass]="(brand === 'Audi Now' || brand === 'AU') ? 'theme-audi' : 'theme-vw'">
  <div class="flex-child-edge flex-left-bar"></div>
  <div class="flex-child-text">
    <div class="logo" *ngIf="brand !== 'Audi Now' && brand !== 'AU'"></div>
  </div>
  <div class="flex-child-edge"></div>
</div>

<div class="heading">
  <h1><!-- <span>{{brand}}</span> - My Apps Links  -->
    <span *ngIf="isAdminPage" class="sub-heading">Admin</span>
  </h1>
  <div class="lang-selection">
    <span class="username" *ngIf="user">{{ 'welcome' | translate }}, {{user?.userName}}</span>
    <div class="language-row" *ngIf="(user?.country == 'CA' || lastSelectedLanguage=='fr')">
      <span>{{ 'language' | translate }}: </span>
      <span class="link-button" (click)="selectLanguage('en')" [class.active]="lastSelectedLanguage === 'en'"> EN </span>
      <span class="link-button v-divider">|</span>
      <span class="link-button" (click)="selectLanguage('fr')" [class.active]="lastSelectedLanguage === 'fr'"> FR </span>
    </div>
  </div>
</div>